module.exports = __webpack_public_path__ + "static/media/sitrack.4cd8a630.svg";